import { render, staticRenderFns } from "./modelList.vue?vue&type=template&id=dcc55df2&scoped=true"
import script from "./modelList.vue?vue&type=script&lang=js"
export * from "./modelList.vue?vue&type=script&lang=js"
import style0 from "./modelList.vue?vue&type=style&index=0&id=dcc55df2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc55df2",
  null
  
)

export default component.exports